/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  StyledContainer,
  TableCell,
  TableWrapper,
  IconButton,
  LoaderWrapper,
} from '../../../services/settings/appStyle/global.style';

import {
  Table,
  IconButton as IconButtonWithText,
  DeleteConfirmationModal,
  Loader,
  DropdownButton,
} from '../../../Components/uielements';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useUserContext } from '../../../hooks/UserContext';
import GeofenceService, {
  listAllGeofencesByCompany,
} from '../../../services/bioplus-services/geofence';
// import PremiseService from '../../../services/bioplus-services/premise';
import { DeleteIcon, EditIcon, EyeIcon, WhiteLocationIcon } from '../../../Components/icons';
import moment from 'moment';
import { OwnerEditGeofenceModal } from './modals';
import { HeaderButtonWrapper } from './geofence.style';
import { useNavigate } from 'react-router-dom';
import { IntlMessages } from '../../../helper/langHelper';
import { exportExcelFile } from '../../../helper/exportExcelHelper';
import { formatDropdownData } from './helper';
import { DeleteErrorModal } from '../../../Components/uielements/deleteComfirmationModal/deleteConfirmationModal';
import { ViewAlertReceivers } from '../PremiseV2/modals';
// import { convertToUserTimeZoneDateTime } from '../../../helper/dataFormat';

export function extractData(dataArray) {
  if (dataArray && dataArray.length > 0) {
    const extractedData = dataArray?.map((item) => {
      return {
        GeofenceName: item?.name,
        CompanyName: item?.premiseId?.propertyName,
        DeclarationType: item?.declarationType,
        speed: item?.speedLimit,
        Creator: item?.createdBy,
        createdAt: moment(item?.createdAt).format('DD-MM-YYYY'),
        AlertReceivers: item?.alertReceiverCount ?? 0,
      };
    });
    return { bioplusUsers: extractedData };
  }
}

const listByCompany = async ({ showAll, ...options }, page, pageSize) => {
  if (showAll) {
    return await GeofenceService.listByCompany(options, page, pageSize);
  } else {
    return await GeofenceService.listByCompanyManager(options, page, pageSize);
  }
};

const OwnerGeofence = () => {
  const userContext = useUserContext();
  const userRole = userContext.company;
  const queryClient = useQueryClient();
  const companyId = userRole?.companyId?.id;
  const navigate = useNavigate();

  const [editGeofence, setEditGeofence] = useState();
  const [deleteGeofence, setDeleteGeofence] = useState();
  const [showAll, setShowAll] = useState(true);
  const [geofenceDeleteError, setGeofenceDeleteError] = useState(undefined);
  const [viewAlertReceivers, setViewAlertReceivers] = useState(undefined);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const geofenceQuery = useQuery(
    ['geofences', userContext?.company?.companyId, true, showAll, page, pageSize],
    () =>
      listByCompany(
        {
          companyId: userContext?.company?.companyId?.id,
          occupants: true,
          showAll: showAll,
        },
        page,
        pageSize
      )
  );

  const getAllGeofencesForReport = useQuery(
    ['allGeofencesForReport', userContext?.company?.companyId, true, showAll, page, pageSize],
    () => listAllGeofencesByCompany(userContext?.company?.companyId?.id)
  );

  // const { data: premisesData } = useQuery(['premises', companyId], () =>
  //   PremiseService.listByCompany(companyId)
  // );
  // const { data: premisesData } = useQuery(['premises', companyId], () =>
  //   PremiseService.listAllByCompany(companyId, {})
  // );
  const deleteMutation = useMutation({
    mutationFn: (geofence) => {
      return GeofenceService.remove(geofence);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['geofences'] });
    },

    onError: (error) => {
      setGeofenceDeleteError(error?.response?.data?.message);
    },
  });

  const geofenceTableData = geofenceQuery?.data?.geofences ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  const handleDeleteGeofence = (geofence) => {
    deleteMutation.mutate(geofence);
    setDeleteGeofence(undefined);
  };

  const userTimeZone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);

  // Role based permission check for the "geofence" module
  const { userPermission } = userContext;
  const isUserAllowToManage = userPermission?.find(
    (permission) => permission?.label === 'geofence'
  );

  const canManageGeofence = !!isUserAllowToManage?.isManage;
  const canDownloadReport = !!isUserAllowToManage?.isReport;

  //   table coulmns
  const userColumns = useMemo(() => {
    const cols = [
      {
        Header: <IntlMessages id="table.col.geofence" />,
        accessor: 'name',
        width: '14%',
      },
      {
        Header: <IntlMessages id="table.col.premise" />,
        accessor: 'premiseId.propertyName',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '12%',
      },
      {
        Header: <IntlMessages id="table.col.dec.type" />,
        accessor: 'declarationType',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '12%',
      },
      {
        Header: <IntlMessages id="table.col.speed.limit" />,
        accessor: 'speedLimit',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '12%',
      },

      // {
      //   Header: <IntlMessages id="table.col.occupied.reg" />,
      //   accessor: 'registeredOccupants',
      // },
      // {
      //   Header: <IntlMessages id="table.col.occupied.unReg" />,
      //   accessor: 'unregisteredOccupants',
      // },
      {
        Header: <IntlMessages id="table.col.creator" />,
        accessor: 'createdBy',
        width: '14%',
      },
      {
        Header: <IntlMessages id="table.col.createdAt" />,
        accessor: 'createdAt',
        width: '12%',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
      // {
      //   Header: <IntlMessages id="table.col.updateAt" />,
      //   accessor: 'updatedAt',
      //   width: '12%',
      //   Cell: (cellData) => (
      //     <TableCell>
      //       {cellData.value ? convertToUserTimeZoneDateTime(cellData.value, userTimeZone) : '--'}
      //     </TableCell>
      //   ),
      // },
      // {
      //   Header: <IntlMessages id="table.col.updateBy" />,
      //   accessor: 'updatedBy',
      //   width: '14%',
      // },
      // {
      //   Header: <IntlMessages id="table.col.alert.receivers" />,
      //   accessor: 'alertReceiverCount',
      //   width: '12%',
      //   Cell: (cellData) => (
      //     <TableCell
      //       onClick={() => setViewAlertReceivers(cellData?.row?.original)}
      //       style={{ display: 'flex', gap: '6px' }}
      //     >
      //       <span style={{ alignSelf: 'center' }}>{cellData.value}</span>
      //       <EyeIcon style={{ width: '22px', height: '22px', cursor: 'pointer' }} />
      //     </TableCell>
      //   ),
      // },
    ];

    if (canManageGeofence) {
      cols.push({
        Header: <IntlMessages id="table.col.alert.receivers" />,
        accessor: 'alertReceiverCount',
        width: '12%',
        Cell: (cellData) => (
          <TableCell
            onClick={() => setViewAlertReceivers(cellData?.row?.original)}
            style={{ display: 'flex', gap: '6px' }}
          >
            <span style={{ alignSelf: 'center' }}>{cellData.value}</span>
            <EyeIcon style={{ width: '22px', height: '22px', cursor: 'pointer' }} />
          </TableCell>
        ),
      });
    }

    // Only show the Actions column (Edit/Delete) if the user has manage permission
    if (canManageGeofence) {
      cols.push({
        Header: <IntlMessages id="table.col.actions" />,
        accessor: 'actions',
        isAction: true,
        width: '15%',
      });
    }

    // Rescale widths so visible columns always fill 100%, regardless of
    // whether the alert-receivers/actions columns were included above.
    // Fixes the empty gap on the right when canManageGeofence is false.
    const totalWidth = cols.reduce((sum, col) => sum + parseFloat(col.width || 0), 0);

    return totalWidth > 0
      ? cols.map((col) => ({
          ...col,
          width: `${(parseFloat(col.width || 0) / totalWidth) * 100}%`,
        }))
      : cols;
  }, [userTimeZone, canManageGeofence]);

  const handleNavigationToMap = (data) => {
    if (data) {
      navigate('/geofenceMap', { state: { data } });
    }
  };

  // Edit/Delete actions — column itself is only rendered when canManageGeofence is true
  const actionList = [
    // (data) => (
    //   <IconButton onClick={() => setEditGeofence(data)}>
    //     <EditIcon style={{ width: '18px', height: '18px' }} />
    //   </IconButton>
    // ),
    (data) => (
      <IconButton onClick={() => handleNavigationToMap(data)}>
        <EditIcon style={{ width: '22px', height: '22px' }} />
      </IconButton>
    ),
    (data) => (
      <IconButton onClick={() => setDeleteGeofence(data)}>
        <DeleteIcon style={{ width: '20px', height: '20px' }} />
      </IconButton>
    ),
  ];

  const excelFormatData = extractData(getAllGeofencesForReport.data);
  const fileName = `Geofences-${userRole?.companyId?.name}-${moment().format(
    'DD-MM-YYYY-hh.mm A'
  )}.xlsx`;
  const fileNameCsv = `Geofences-${userRole?.companyId?.name}-${moment().format(
    'DD-MM-YYYY-hh.mm A'
  )}.csv`;
  const columnConfig = [
    { header: 'Geofence Name', key: 'GeofenceName', width: 30 },
    { header: 'Property Name', key: 'CompanyName', width: 30 },
    { header: 'Declaration Type', key: 'DeclarationType', width: 20 },
    { header: 'Speed Limit', key: 'speed', width: 10 },
    { header: 'Creator', key: 'Creator', width: 30 },
    { header: 'Created Date', key: 'createdAt', width: 20 },
    { header: 'Alert Receivers', key: 'AlertReceivers', width: 20 },
  ];
  const handleClickItem = (item) => {
    // Guard: even if triggered programmatically, block export without report permission
    if (!canDownloadReport) return;

    switch (item?.key) {
      case 'excel':
        exportExcelFile(excelFormatData, fileName, columnConfig);
        break;
      case 'pdf':
        break;
      case 'csv':
        exportExcelFile(excelFormatData, fileNameCsv, columnConfig);
        break;
      default:
        break;
    }
  };

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.geofences" />
        </HeaderTitle>
        <HeaderButtonWrapper>
          {/* <SwitchButtonWrapper>
            <Switch handleToggle={() => setShowAll(!showAll)} />
            <SwitcherLabel>
              <IntlMessages id="button.text.show.all" />
            </SwitcherLabel>
          </SwitchButtonWrapper> */}
          {excelFormatData && canDownloadReport && (
            <DropdownButton
              noOfColoumns={1}
              buttonArray={[
                { key: 'excel', title: 'Export as Excel', icon: <CloudDownloadIcon /> },
                // { key: 'pdf', title: 'Export as PDF', icon: <PictureAsPdfIcon /> },
                { key: 'csv', title: 'Export as CSV', icon: <SimCardDownloadIcon /> },
              ]}
              onClick={handleClickItem}
            />
          )}
          <IconButtonWithText
            text={<IntlMessages id="button.text.viewMap" />}
            icon={<WhiteLocationIcon style={{ width: '20px', height: '19px' }} />}
            onClick={() => navigate('/geofenceMap', { state: { isView: true } })}
          />
        </HeaderButtonWrapper>
      </CompanyContainer>

      {geofenceQuery.isLoading ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <>
          {' '}
          <TableWrapper>
            <Table
              data={geofenceTableData}
              columns={userColumns}
              hasFooter={true}
              page={page}
              pageSize={pageSize}
              prevPage={handlePreviousPage}
              nextPage={handleNextPage}
              total={geofenceQuery?.data?.totalGeofence || 0}
              actions={actionList}
            />
          </TableWrapper>
        </>
      )}
      {editGeofence && editGeofence !== undefined && canManageGeofence && (
        <OwnerEditGeofenceModal
          onClose={() => setEditGeofence(undefined)}
          data={editGeofence}
          // premisesData={formatDropdownData(premisesData)}
        />
      )}

      {deleteGeofence && canManageGeofence && (
        <DeleteConfirmationModal
          onClose={() => setDeleteGeofence(undefined)}
          message={
            <IntlMessages
              id="geofence.delete.confirmation"
              values={{ geofence: deleteGeofence.name }}
            />
          }
          onConfirm={() => handleDeleteGeofence(deleteGeofence)}
        />
      )}
      {geofenceDeleteError && (
        <DeleteErrorModal
          onClose={() => setGeofenceDeleteError(undefined)}
          errorMessage={geofenceDeleteError}
        />
      )}
      {/* Note: alertReceiver code moved from the premise to geofence; needs to be refactored later. Lots of CSS and files need to be moved */}

      {viewAlertReceivers && viewAlertReceivers !== undefined && (
        <ViewAlertReceivers
          onClose={() => setViewAlertReceivers(undefined)}
          premise={viewAlertReceivers}
          companyId={companyId}
          invalidateQuery="geofences"
        />
      )}
    </StyledContainer>
  );
};

export default OwnerGeofence;
